export class SendMessageActionSettings {
    static $inject = ['init'];
    constructor(init) {
        this.metadata = {};
        Object.assign(this, init);
    }
}
